import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae705ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello-banner" }
const _hoisted_2 = { class: "banner-text" }
const _hoisted_3 = { class: "table-header" }
const _hoisted_4 = { class: "header-title pl-2 pt-1 pb-1 w-full" }
const _hoisted_5 = { class: "header-label" }
const _hoisted_6 = { class: "first-title text-left" }
const _hoisted_7 = { class: "not-first-title ml-1 text-center" }
const _hoisted_8 = { class: "not-first-title ml-1 text-center" }
const _hoisted_9 = { class: "header-checkbox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_13 = { class: "contact-side" }
const _hoisted_14 = { class: "popup-container" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "popup-container" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  class: "popup-container",
  ref: "popup"
}
const _hoisted_19 = { class: "popup-edit-field" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "row w-full" }
const _hoisted_22 = { class: "popup-edit-field mt-2" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "popup-edit-field mt-2" }
const _hoisted_25 = { class: "input-label" }
const _hoisted_26 = { class: "popup-edit-field mt-2" }
const _hoisted_27 = { class: "input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationTextField = _resolveComponent("ValidationTextField")!
  const _component_MemberTile = _resolveComponent("MemberTile")!
  const _component_LoadMore = _resolveComponent("LoadMore")!
  const _component_FlatButton = _resolveComponent("FlatButton")!
  const _component_AfterLoginPageLayout = _resolveComponent("AfterLoginPageLayout")!
  const _component_flat_button = _resolveComponent("flat-button")!
  const _component_popup = _resolveComponent("popup")!
  const _component_validation_text_field = _resolveComponent("validation-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AfterLoginPageLayout, {
      class: "contact-page",
      "is-sub-header-menu": false,
      "right-part-popup": true,
      onOnMaxScroll: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreContacts(true)))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.total
              ? `${_ctx.$t("contact.bannerTitle")} (${_ctx.total})`
              : _ctx.$t("contact.bannerTitle")), 1)
        ])
      ]),
      topLeft: _withCtx(() => [
        _createVNode(_component_ValidationTextField, {
          "suffix-icon": require('icons/close-black.svg'),
          "prefix-icon": require('icons/search-placeholder.svg'),
          placeholder: _ctx.$t('contact.searchHint'),
          "keep-error-space": false,
          "suffix-icon-action": _ctx.clearSearch,
          class: "search-bar",
          name: "search-bar",
          value: _ctx.searchKeywordTextField,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKeywordTextField) = $event)),
          onOnInput: _ctx.search
        }, null, 8, ["suffix-icon", "prefix-icon", "placeholder", "suffix-icon-action", "value", "onOnInput"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("contact.memberName")), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("contact.memberGroup")), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("contact.memberCompany")), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search(_ctx.searchKeyword))),
                class: "mr-1",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAllContacts) = $event))
              }, null, 544), [
                [_vModelCheckbox, _ctx.isAllContacts]
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("contact.showAll")), 1)
            ])
          ]),
          _hoisted_10
        ])
      ]),
      bottomLeft: _withCtx(() => [
        (_ctx.contacts && _ctx.contacts.length == 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "content-blank",
              innerHTML: _ctx.$t('contact.emptyList')
            }, null, 8, _hoisted_11))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contacts, (contact) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "member-row",
                key: contact.id
              }, [
                _createVNode(_component_MemberTile, {
                  contact: contact,
                  onOnShowEditPopup: _ctx.onShowEditContact,
                  onOnShowHidePopup: ($event: any) => (_ctx.isShowHidePopup = contact),
                  onOnShowDeletePopup: ($event: any) => (_ctx.isShowDeletePopup = contact)
                }, null, 8, ["contact", "onOnShowEditPopup", "onOnShowHidePopup", "onOnShowDeletePopup"]),
                _hoisted_12
              ]))
            }), 128)),
        (_ctx.contacts && _ctx.contacts.length > 0)
          ? (_openBlock(), _createBlock(_component_LoadMore, {
              key: 2,
              "on-load-more": _ctx.loadMoreContacts
            }, null, 8, ["on-load-more"]))
          : _createCommentVNode("", true)
      ]),
      topRight: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_FlatButton, {
            text: _ctx.$t('contact.addButton'),
            icon: require('icons/add-white.svg'),
            class: "w-full",
            onOnClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowAddPopup = true)),
            enabled: _ctx.contactPermissions.canCreate
          }, null, 8, ["text", "icon", "enabled"])
        ])
      ]),
      _: 1
    }),
    (_ctx.isShowDeletePopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          title: _ctx.$t('contact.deleteTitle'),
          onOnClickOutsidePopup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowDeletePopup = null)),
          onOnHide: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowDeletePopup = null))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", {
                class: "message",
                innerHTML: 
        _ctx.$t('contact.deleteMessage', { lastName: _ctx.isShowDeletePopup.lastName, firstName: _ctx.isShowDeletePopup.firstName })
      
              }, null, 8, _hoisted_15),
              _createVNode(_component_flat_button, {
                text: _ctx.$t('group.buttonPopup'),
                class: "confirm-btn mt-5",
                onOnClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDelete(_ctx.isShowDeletePopup)))
              }, null, 8, ["text"])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.isShowHidePopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          title: 
      !_ctx.isShowHidePopup.isHidden
        ? _ctx.$t('contact.hideTitle')
        : _ctx.$t('contact.unHideTitle')
    ,
          onOnClickOutsidePopup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowHidePopup = null)),
          onOnHide: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowHidePopup = null))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", {
                class: "message",
                innerHTML: 
          !_ctx.isShowHidePopup.isHidden
            ? _ctx.$t('contact.hideMessage', { lastName: _ctx.isShowHidePopup.lastName, firstName: _ctx.isShowHidePopup.firstName })
            : _ctx.$t('contact.unHideMessage', { lastName: _ctx.isShowHidePopup.lastName, firstName: _ctx.isShowHidePopup.firstName })
        
              }, null, 8, _hoisted_17),
              _createVNode(_component_flat_button, {
                text: 
          !_ctx.isShowHidePopup.isHidden
            ? _ctx.$t('contact.hideConfirm')
            : _ctx.$t('contact.unHideConfirm')
        ,
                class: "confirm-btn mt-5",
                onOnClick: _cache[8] || (_cache[8] = ($event: any) => (
          !_ctx.isShowHidePopup.isHidden
            ? _ctx.onHide(_ctx.isShowHidePopup)
            : _ctx.onUnHide(_ctx.isShowHidePopup)
        ))
              }, null, 8, ["text"])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.isShowEditPopup || _ctx.isShowAddPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          title: _ctx.isShowEditPopup ? _ctx.$t('contact.editTitle') : _ctx.$t('contact.addTitle'),
          onOnClickOutsidePopup: _ctx.hideContactInfoPopup,
          onOnHide: _ctx.hideContactInfoPopup,
          class: "contact-edit-popup"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('contact.name'),
                  class: "input-label"
                }, null, 8, _hoisted_20),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_validation_text_field, {
                    placeholder: _ctx.$t('common.lastnameHint'),
                    "keep-error-space": false,
                    class: "half-width",
                    name: "lastName",
                    rules: "name|required",
                    message: {
              error_required: _ctx.$t('errors.required'),
              error_format_name: _ctx.$t('errors.formatName'),
            }
                  }, null, 8, ["placeholder", "message"]),
                  _createVNode(_component_validation_text_field, {
                    placeholder: _ctx.$t('common.firstnameHint'),
                    "keep-error-space": false,
                    class: "half-width",
                    name: "firstName"
                  }, null, 8, ["placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('contact.mail'),
                  class: "input-label"
                }, null, 8, _hoisted_23),
                _createVNode(_component_validation_text_field, {
                  placeholder: _ctx.$t('common.email'),
                  "keep-error-space": false,
                  "max-length": 320,
                  message: {
            error_required: _ctx.$t('errors.required'),
            error_format_email: _ctx.$t('errors.formatEmail'),
          },
                  name: "email",
                  rules: "required|email"
                }, null, 8, ["placeholder", "message"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("contact.company")), 1),
                _createVNode(_component_validation_text_field, {
                  placeholder: '',
                  "keep-error-space": false,
                  name: "companyName"
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("contact.group")), 1),
                _createVNode(_component_validation_text_field, {
                  placeholder: '',
                  "keep-error-space": false,
                  name: "department"
                })
              ])
            ], 512),
            _createElementVNode("div", {
              class: _normalizeClass(["section-footer", { 'have-divider': _ctx.isOverflow }])
            }, [
              (_ctx.isShowEditPopup)
                ? (_openBlock(), _createBlock(_component_flat_button, {
                    key: 0,
                    text: _ctx.$t('contact.changeButton'),
                    class: "w-full",
                    onOnClick: _ctx.submitEdit
                  }, null, 8, ["text", "onOnClick"]))
                : _createCommentVNode("", true),
              (_ctx.isShowAddPopup)
                ? (_openBlock(), _createBlock(_component_flat_button, {
                    key: 1,
                    text: _ctx.$t('contact.addConfirmButton'),
                    class: "w-full",
                    onOnClick: _ctx.submitCreate
                  }, null, 8, ["text", "onOnClick"]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["title", "onOnClickOutsidePopup", "onOnHide"]))
      : _createCommentVNode("", true)
  ], 64))
}